import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { UrlService } from '../../../../environments/urlService';
import { EmployeeAccessLevel } from '../dto/Employee';
import { EmployeeCheckBoxByTable } from '../components/shared/team-table/team-table.component';
import { IS_SPINNER_ACTIVE } from 'src/app/util/interceptors';
import { EmployeeCrudDTO } from 'src/app/domain/company/dto/EmployeeCRUDDTO';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class EmployeeService {

  private readonly url: string;

  constructor(private http: HttpClient,
    private urlService: UrlService,
  ) {
    this.url = this.urlService.getFmsUrl() + 'employee';
  }

  get(orgUUID: string): Promise<EmployeeCrudDTO[]> {
    return this.http.get<EmployeeCrudDTO[]>(this.url, {
      params: { orgUUID }, withCredentials: true,
      responseType: 'json',
    }).toPromise();
  }

  update(employee: EmployeeCrudDTO, isKPIOnly: boolean): Promise<EmployeeCrudDTO> {
    return this.http.put<EmployeeCrudDTO>(this.url, employee, {
      params: { isKPIOnly },
      withCredentials: true,
    }).toPromise();
  }


  updateCheckBox(employeeId: number, field: EmployeeCheckBoxByTable, value: boolean): Promise<boolean> {
    return this.http.put<boolean>(`${this.url}/${employeeId}/${field}`, value, {
      withCredentials: true,
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      responseType: 'json',
    }).toPromise();
  }

  updateRecoveryOrgAdmin(employeeId: number, isOrgAdmin: boolean): Observable<boolean> {
    const url = this.urlService.getFmsUrl() + 'recovery/employee';
    return this.http.put<boolean>(`${url}/${employeeId}/org-admin`, null, {
      params: { isOrgAdmin },
      withCredentials: true,
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
    });
  }


  updateAccessLevel(employeeId: number, value: EmployeeAccessLevel): Promise<void> {
    return this.http.put<void>(`${this.url}/${employeeId}/accessLevel`, value, {
      withCredentials: true,
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      responseType: 'json',
    })
      .toPromise();
  }

  updateKpiAccessLevel(employeeId: number, value: EmployeeAccessLevel): Observable<void> {
    return this.http.put<void>(`${this.url}/${employeeId}/kpi-accessLevel`, value, {
      withCredentials: true,
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
    });
  }

  updateFinancialStatementAccessLevel(employeeId: number, accessLevel: EmployeeAccessLevel): Observable<void> {
    return this.http.put<void>(`${this.url}/${employeeId}/fs-accessLevel`, accessLevel, {
      withCredentials: true,
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
    });
  }

  create(employee: EmployeeCrudDTO, isKpi: boolean = null): Observable<EmployeeCrudDTO> {
    return this.http.post<EmployeeCrudDTO>(this.url, employee, {
      params: { isKpi },
      withCredentials: true,
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
    });
  }

  delete(employeeUUID: string): Promise<void> {
    return this.http.delete<void>(this.url + '/' + employeeUUID, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true, responseType: 'json',
    })
      .toPromise();
  }

  reInviteUser(updatedTeamMember: EmployeeCrudDTO): Promise<boolean> {
    return this.http.post<boolean>(this.url + '/reinvite', updatedTeamMember, {
      withCredentials: true,
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      responseType: 'json',
    }).toPromise();
  }

}

